import { MyCatalogModal } from "../my_catalog_modal";

export const createRrItemModalRequestParam = (model: MyCatalogModal, catalogItemCode: string) => {
    return {
      isLogin: model.isLogin,
      userId: model.userId,
      userTracking: model.userTracking,
      userSegments: model.userSegments,
      setRrRequestParams: setRrItemModalRequestParams,
      pageOption: {
        placementNameMyCatalogModal:
        model.rrAreaProfileMyCatalogModal!.placementName,
        catalogItemCode: catalogItemCode
      },
    };
};

export const setRrItemModalRequestParams = (R3_COMMON: r3_common, pageOption: any) => {
    const R3_ADDTOCART = new r3_addtocart();
    R3_COMMON.addPlacementType(`add_to_cart_page.${pageOption.placementNameMyCatalogModal}`);
    R3_ADDTOCART.addItemIdToCart(pageOption.catalogItemCode);
};